import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Zap, Moon, Sun, Shield } from 'lucide-react';
export function UniqueMechanism() {
  return <div className="bg-navy text-cream relative overflow-hidden" data-id="element-188">
      {/* Decorative glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-189"></div>

      <SectionWrapper className="relative z-10" data-id="element-190">
        <div className="max-w-4xl mx-auto text-center" data-id="element-191">
          <div className="inline-flex items-center justify-center p-3 bg-gold/10 rounded-full mb-8 text-gold" data-id="element-192">
            <Zap size={32} data-id="element-193" />
          </div>

          <h2 className="text-3xl md:text-5xl font-serif text-white mb-8" data-id="element-194">
            Presentamos el{' '}
            <span className="text-gold" data-id="element-195">
              Mecanismo de Sincronización de Supervivencia
            </span>{' '}
            (MSS).
          </h2>

          <p className="text-xl font-sans text-cream/90 leading-relaxed mb-12" data-id="element-196">
            A diferencia de otros métodos, el MSS no solo entrena al bebé;
            sincroniza tu energía profesional con los ciclos biológicos de tu
            hijo.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left mt-16" data-id="element-197">
            <div className="bg-navy-light/50 p-8 rounded-sm border-l-4 border-gold" data-id="element-198">
              <div className="flex items-center mb-4 text-gold" data-id="element-199">
                <Moon className="mr-3" size={24} data-id="element-200" />
                <h3 className="text-xl font-serif text-white" data-id="element-201">
                  Ventanas de Presión
                </h3>
              </div>
              <p className="text-cream/70 font-sans" data-id="element-202">
                Es una estrategia logística que garantiza que el bebé esté listo
                para dormir exactamente cuando tú necesitas descansar.
              </p>
            </div>

            <div className="bg-navy-light/50 p-8 rounded-sm border-l-4 border-gold" data-id="element-203">
              <div className="flex items-center mb-4 text-gold" data-id="element-204">
                <Sun className="mr-3" size={24} data-id="element-205" />
                <h3 className="text-xl font-serif text-white" data-id="element-206">
                  Micro-siestas de Rescate
                </h3>
              </div>
              <p className="text-cream/70 font-sans" data-id="element-207">
                Técnicas diseñadas para que tu cerebro funcione al máximo en la
                oficina, incluso en los días más difíciles tras una mala noche.
              </p>
            </div>
          </div>
        </div>
      </SectionWrapper>
    </div>;
}